// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","logo":"logo__jPF5-","modalContainer":"modalContainer__hEy+-"};